export default "__VITE_ASSET__0e57c1b6__"